import React, { useEffect, lazy, Suspense } from 'react';
import { hot } from 'react-hot-loader/root';
import { Helmet } from 'react-helmet';

import { useCurrentUser } from './shared/contexts/UserProvider';
import { Loader } from './shared/components';
// import 'antd/dist/reset.css';

const loadAuthenticatedApp = () => import('./AuthenticatedApp');
const AuthenticatedApp = lazy(loadAuthenticatedApp);
const UnauthenticatedApp = lazy(() => import('./UnauthenticatedApp'));

const App = () => {
  const user = useCurrentUser();

  useEffect(() => {
    loadAuthenticatedApp();
  }, []);
  const isGoVolunteer = window?.location?.hostname?.includes('govolunteer');
  const PAGE_TITLE = isGoVolunteer ? 'GoVolunteer Admin' : 'GoNature Admin';

  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
      </Helmet>
      <Suspense fallback={<Loader />}>
        {user ? <AuthenticatedApp /> : <UnauthenticatedApp />}
      </Suspense>
    </>
  );
};

export default hot(App);
